import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class SuccessPosReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/successPosReport',
      requesterInfo,
    })
  }

  // Company boş bırakılırsa tüm şirketler, Mails boş bırakılırsa koddaki varsayılan adresler.
  public async sendSuccessPosReport(req: {
    StartDate: Date
    EndDate: Date
    Company?: number | null
    Mails?: string[]
  }): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
